import type { AssistantTurn } from '../state/conversationStore';

interface Props {
  turns: AssistantTurn[];
}

export function StatusBar({ turns }: Props) {
  const last = turns.at(-1);
  const sessionTurns = turns.length;
  return (
    <div style={{ fontSize: 12, color: '#666', display: 'flex', gap: 16 }}>
      <span>session_turns: {sessionTurns}</span>
      {last?.first_token_ms !== undefined && <span>last first_token: {last.first_token_ms}ms</span>}
      {last?.total_ms !== undefined && <span>last total: {last.total_ms}ms</span>}
    </div>
  );
}
